import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Button,
} from "@mui/material";
import { useEffect, useState } from "react";
import ErrorsString from "../ErrorsString";
import config from "../config";
import { GetShareModel } from "../models/GetShareModel";
import { useParams } from "react-router-dom";
import { ShareResponse } from "../models/ResponseModels/ShareResponse";
import Spinner from "../components/Spinner";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { saveAs } from "file-saver";
import ScrollToTopButton from "../components/ScrollToTopButton";
import TagList from "../components/TagList";
import { logDownload } from "../Utilities";

export default function SharedLandingPage() {
  const { token } = useParams();
  const [spinnerVisibility, setSpinnerVisibility] = useState(false);
  let [alertMessage, setAlertMessage] = useState<string>("");
  let [showAlert, setShowAlert] = useState<boolean>(false);
  const [details, setDetails] = useState<ShareResponse | null>(null);

  useEffect(() => {
    getImageDetails();
  }, []);

  function getImageDetails() {
    console.log("Starting API call GetShareModel...");
    (async () => {
      const response = await GetShareModel(token);
      //console.log("GetShareModel response: " + JSON.stringify(response));

      const responseData = response?.data;
      const statusCode = response?.status;

      if (responseData === undefined) {
        setShowAlert(true);
        setAlertMessage(ErrorsString.errorMessageGeneric);
        setSpinnerVisibility(false);
        return;
      }

      if (statusCode !== 200) {
        setShowAlert(true);
        setAlertMessage(ErrorsString.errorMessageGeneric);
        setSpinnerVisibility(false);
        return;
      } else {
        setDetails(responseData);
        setSpinnerVisibility(false);
      }
    })();
  }

  function downloadOriginalImage() {
    if (details.essence) {
      const url =
        config.cloudfrontImgUrl + "" + details.essence + config.showImagesQuery;
      let imageFileName = "";
      if (details.title_image) {
        imageFileName = details.title_image;
      } else {
        const today = new Date();
        const formattedDate = today.toLocaleDateString();
        imageFileName = "image" + formattedDate;
      }

      const fileExtension = details.file_extension
        ? details.file_extension
        : "jpg";
      imageFileName = imageFileName + "." + fileExtension;

      saveAs(url, imageFileName);

      logDownload(details.uuid, null);
    }
  }

  const DetailRow = ({ id, label, value }) => {
    const isArray = Array.isArray(value);
    const isValueNull = isArray ? value.length === 0 : value == null;
    if (isValueNull) return null;

    return (
      <div id={id} className="text-xl mb-3 flex">
        <div className="-w-40 font-skyBold -text-right">{label}:</div>
        <span className="ml-2">
          {" "}
          {Array.isArray(value) ? value.join(", ") : value}
        </span>
      </div>
    );
  };

  return (
    <>
      <Spinner visibility={spinnerVisibility} />

      <ScrollToTopButton></ScrollToTopButton>

      {details ? (
        <div id="image-body">
          <div id="actions" className="mb-4 mr-4">
            <Button
              className="float-right "
              variant="contained"
              color="primary"
              onClick={() => downloadOriginalImage()}
            >
              Download
            </Button>
          </div>
          <div className="flex">
            <div id="image-preview" className="p-4 w-1/2 h-1/2">
              <img
                src={
                  details.proxy != null
                    ? config.cloudfrontImgUrl +
                      "" +
                      details.proxy +
                      config.showImagesQuery
                    : config.placeholderImageUrl
                }
                className="w-full h-full"
                alt={details.proxy}
              />
            </div>
            <div id="image-details" className=" p-4 w-1/2 mt-4">
              <div id="details" className=" mt-8">
                <Accordion defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel3-content"
                    id="panel3-header"
                    className="font-skyRegular text-xl"
                  >
                    File
                  </AccordionSummary>
                  <AccordionDetails>
                    <DetailRow
                      id="title"
                      label="Title"
                      value={details.title_image}
                    />
                    <DetailRow
                      id="file_extension"
                      label="Extension"
                      value={details.file_extension}
                    />
                    <DetailRow
                      id="type"
                      label="Type"
                      value={details.image_type}
                    />
                    <DetailRow
                      id="file-Size"
                      label="Size"
                      value={
                        details.fileSizeBytes
                          ? (parseFloat(details.fileSizeBytes) / 1024).toFixed(
                              2
                            ) + " KB"
                          : null
                      }
                    />
                  </AccordionDetails>
                </Accordion>

                <Accordion defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel3-content"
                    id="panel3-header"
                    className="font-skyRegular text-xl"
                  >
                    Dimension
                  </AccordionSummary>
                  <AccordionDetails>
                    <DetailRow
                      id="width"
                      label="Width"
                      value={details.width ? `${details.width} px` : null}
                    />
                    <DetailRow
                      id="height"
                      label="Height"
                      value={details.height ? `${details.height} px` : null}
                    />
                  </AccordionDetails>
                </Accordion>

                <Accordion defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel3-content"
                    id="panel3-header"
                    className="font-skyRegular text-xl"
                  >
                    General
                  </AccordionSummary>
                  <AccordionDetails>
                    {/*
                    <DetailRow
                      id="tags"
                      label="Tags"
                      value={
                        details.tags && Object.keys(details.tags).length > 0 ? (
                          <TagList tags={details.tags} />
                        ) : null
                      }
                    />
                    */}
                    <DetailRow
                      id="description"
                      label="Description"
                      value={details.description}
                    />
                    <DetailRow
                      id="collection_title"
                      label="Collection Title"
                      value={details.title_workorder_linked}
                    />
                    <DetailRow
                      id="channel"
                      label="Channel"
                      value={details.channel_workorder}
                    />
                    <DetailRow
                      id="creator"
                      label="Creator"
                      value={details.creator}
                    />
                    <DetailRow
                      id="subject_person"
                      label="Person Shown"
                      value={details.subject_person}
                    />
                  </AccordionDetails>
                </Accordion>

                <Accordion defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel3-content"
                    id="panel3-header"
                    className="font-skyRegular text-xl"
                  >
                    Usage Rights
                  </AccordionSummary>
                  <AccordionDetails>
                    <DetailRow
                      id="copyright"
                      label="Copyright"
                      value={details.copyright}
                    />
                  </AccordionDetails>
                </Accordion>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <Alert
          severity="error"
          style={{
            display: showAlert ? "flex" : "none",
          }}
        >
          {alertMessage}
        </Alert>
      )}
    </>
  );
}
